exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".conversations-list-container[data-v-f4d2339a]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.conversations-list-list[data-v-f4d2339a]{list-style:none;margin:0;padding:0}@media (min-width:60em){.conversations-list-list[data-v-f4d2339a]{padding:0 53px 0 5px}}.conversations-list-item[data-v-f4d2339a]{border-bottom:1px solid #7f7f7f}", ""]);

// exports
